// «Crear promo venta» desde Inventario: el SKU viaja en el estado de navegación, no en la URL.
export interface SalePromotionPrefill {
    sku: string;
}

declare module '@tanstack/react-router' {
    interface HistoryState {
        salePromotionPrefill?: SalePromotionPrefill;
    }
}

export function salePromotionPrefillState(sku: string): {
    salePromotionPrefill: SalePromotionPrefill;
} {
    return { salePromotionPrefill: { sku } };
}

/** El estado del historial puede venir de otra versión de la app: se valida antes de usarlo. */
export function readSalePromotionPrefill(state: unknown): SalePromotionPrefill | null {
    if (typeof state !== 'object' || state === null) return null;
    const prefill = (state as { salePromotionPrefill?: unknown }).salePromotionPrefill;
    if (typeof prefill !== 'object' || prefill === null) return null;
    const { sku } = prefill as { sku?: unknown };
    return typeof sku === 'string' && sku.trim() !== '' ? { sku: sku.trim() } : null;
}
